import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import * as DASHBOARD_ACTIONS from 'hooks/useDashboard/actions';

import { layouts } from '../content';
import LayoutPreview from '../components/LayoutPreview';
import StepControls from '../components/StepControls';

const LayoutStep = ({ setActiveStep, dispatchDashboard, layoutId }) => {
  const [selectedId, setSelectedId] = useState(layoutId);

  const onSelect = id => {
    setSelectedId(id);
  };

  const handleNext = () => {
    setActiveStep(prev => prev + 1);

    dispatchDashboard({
      type: DASHBOARD_ACTIONS.UPDATED_DASHBOARD,
      payload: { layoutId: selectedId }
    });
  };

  return (
    <>
      <Grid container direction="row" justify="space-around" alignItems="center" spacing={2}>
        {layouts.map(layout => (
          <LayoutPreview
            layout={layout}
            isSelected={selectedId === layout.id}
            onSelect={onSelect}
          />
        ))}
      </Grid>
      <StepControls isFirstStep isNextDisabled={!selectedId} handleNext={handleNext} />
    </>
  );
};

LayoutStep.propTypes = {
  setActiveStep: PropTypes.func.isRequired,
  dispatchDashboard: PropTypes.func.isRequired,
  layoutId: PropTypes.number
};

LayoutStep.defaultProps = {
  layoutId: null
};

export default LayoutStep;
